import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getWeekdayByDate, getMonthNameByDateObject } from '../../../../utils';
import { Button } from '@e2n/ui';

interface DatePickerProps {
  year: string;
  month: string;
  day: string;
}

export function DatePickerSkeleton({ year, month, day }: DatePickerProps) {
  const date = new Date(`${year}-${month}-${day}`);
  return (
    <div className="flex items-center gap-1">
      <Button variant="ghost" className="cursor-wait" disabled>
        <FontAwesomeIcon
          icon={faChevronLeft}
          className="text-neutrals-700 text-xl"
          size="lg"
        />
      </Button>
      <Button variant="ghost" className="cursor-wait" disabled>
        <FontAwesomeIcon
          icon={faChevronRight}
          className="text-neutrals-700 text-xl"
          size="lg"
        />
      </Button>

      <Button
        variant="ghost"
        className={'justify-start text-left text-2xl font-bold'}>
        {`${
          getWeekdayByDate(date).shortage
        }., ${date.getDate()}. ${getMonthNameByDateObject(date)}`}
      </Button>
    </div>
  );
}
